<template>
  <div class="p-20">
    <van-form ref="form" :show-error="false" error-message-align="right">
      <van-cell-group>
        <van-field v-f-show="'flowNo'" :required="isRequired('flowNo')" v-model="formData.flowNo"
                   :rules="getRules('flowNo')" label="编号" input-align="right" readonly/>
        <van-field v-f-show="'yyrq'" v-model="formData.yyrq" :required="isRequired('yyrq')" name="yyrq" label="用印日期"
                   placeholder="用印日期" input-align="right" :rules="getRules('yyrq')">
          <template #input>
            <view-item @click.native="isShowPopup(yyrq,'yyrq')" :value="formData.yyrq" placeholder="请选择用印日期"/>
            <van-calendar :min-date="minDate" v-model="yyrq.show" ref="yyrq" :show-confirm="false" title="选择用印日期"
                          @confirm="yyrqConfirm"></van-calendar>
          </template>
        </van-field>

        <van-field v-f-show="'yywjzl'" input-align="right" name="yywjzl" :required="isRequired('yywjzl')"
                   :value="formData.yywjzl" label="用印文件种类" :rules="getRules('yywjzl')"
                   placeholder="请选择用印文件种类">
          <template #input>
            <view-item @click.native="isShowPopup(yywjzl,'yywjzl')" :value="formData.yywjzl"
                       placeholder="请选择用印文件种类"/>
            <van-popup v-model="yywjzl.show" position="bottom">
              <van-nav-bar title="选择用印文件种类" left-text="取消" right-text="确定" @click-left="yywjzl.show = false"
                           @click-right="popupSubmit('yywjzl')"/>
              <van-search v-model="yywjzl.filterText" @input="pickerSearch($event,yywjzl)" clearable shape="round"/>
              <van-picker ref="yywjzl" value-key="label" :columns="yywjzl.filteredData" @cancel="yywjzl.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'wjfs'" v-model="formData.wjfs" :readonly="isDisabled('wjfs')" type="number"
                   :required="isRequired('wjfs')" :rules="getRules('wjfs')" name="wjfs" maxlength="50" autosize
                   label="文件份数" placeholder="请输入文件份数" input-align="right"/>
        <van-field v-f-show="'yywjmc'" v-model="formData.yywjmc" :disabled="isDisabled('yywjmc')"
                   :required="isRequired('yywjmc')" name="yywjmc" :rules="getRules('yywjmc')" maxlength="50" autosize
                   label="用印文件名称" placeholder="请输入用印文件名称" input-align="right"/>
        <van-field v-f-show="'syhgsz'" input-align="right" name="syhgsz" :required="isRequired('syhgsz')"
                   :value="formData.syhgsz" label="使用何公司章" :rules="getRules('syhgsz')"
                   placeholder="请选择使用何公司章">
          <template #input>
            <view-item @click.native="isShowPopup(syhgsz,'syhgsz')" :value="formData.syhgsz"
                       placeholder="请选择使用何公司章"/>
            <van-popup v-model="syhgsz.show" position="bottom">
              <van-nav-bar title="选择使用何公司章" left-text="取消" right-text="确定" @click-left="syhgsz.show = false"
                           @click-right="popupSubmit('syhgsz')"/>
              <van-search v-model="syhgsz.filterText" @input="pickerSearch($event,syhgsz)" clearable shape="round"/>
              <van-picker ref="syhgsz" value-key="label" :columns="syhgsz.filteredData" @cancel="syhgsz.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'yzlx'" input-align="right" name="yzlx" type="textarea" maxlength="200" rows="3"
                   :required="isRequired('yzlx')" :disabled="isDisabled('yzlx')" v-model="formData.yzlx"
                   label="印章类型" :rules="getRules('yzlx')" placeholder="请选择或输入印章类型">
          <template #input>
            <!--            <view-item @click.native="isShowPopup(yzlx,'yzlx')" :value="formData.yzlx" placeholder="请选择印章类型"/>-->
            <!--            <van-popup v-model="yzlx.show" position="bottom">-->
            <!--              <van-nav-bar title="选择印章类型" left-text="取消" right-text="确定" @click-left="yzlx.show = false" @click-right="popupSubmit('yzlx')"/>-->
            <!--              <van-search v-model="yzlx.filterText" @input="pickerSearch($event,yzlx)" clearable shape="round"/>-->
            <!--              <van-picker ref="yzlx" value-key="label" :columns="yzlx.filteredData" @cancel="yzlx.show = false"/>-->
            <!--            </van-popup>-->
          </template>
        </van-field>
        <div v-if="!isDisabled('yzlx')">
          <el-tag type="info" v-for="(op, index) in yzlx.filteredData" :key="op" @click="handleClick(op)" size="mini"
                  style="margin-left:5px;cursor:pointer;font-size: 12px;padding: 0 3px;line-height: 25px;height: 25px;">
            {{ op }}
          </el-tag>
        </div>
        <van-field v-f-show="'ffwjyz'" input-align="right" name="ffwjyz" :required="isRequired('ffwjyz')"
                   :value="formData.ffwjyz" label="是否外借印章" :rules="getRules('ffwjyz')"
                   placeholder="请选择是否外借印章">
          <template #input>
            <view-item @click.native="isShowPopup(ffwjyz,'ffwjyz')" :value="formData.ffwjyz"
                       placeholder="请选择是否外借印章"/>
            <van-popup   v-model="ffwjyz.show" position="bottom">
              <van-nav-bar title="选择是否外借印章" left-text="取消" right-text="确定" @click-left="ffwjyz.show = false"
                           @click-right="popupSubmitFfwjyz('ffwjyz')"/>
              <van-search v-model="ffwjyz.filterText" @input="pickerSearch($event,ffwjyz)" clearable shape="round"/>
              <van-picker ref="ffwjyz" value-key="label" :columns="ffwjyz.filteredData" @cancel="ffwjyz.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-if="ffwjyzBool||formData.ffwjyz=='是'"  v-f-show="'ghrq'" v-model="formData.ghrq" :required="isRequired('ghrq')" name="ghrq" label="归还日期"
                   placeholder="归还日期" input-align="right" :rules="getRules('ghrq')">
          <template #input>
            <view-item @click.native="isShowPopup(ghrq,'ghrq')" :value="formData.ghrq" placeholder="请选择归还日期"/>
            <van-calendar :min-date="minDate" v-model="ghrq.show" ref="ghrq" :show-confirm="false" title="选择归还日期"
                          @confirm="ghrqConfirm"></van-calendar>
          </template>
        </van-field>
        <van-field v-f-show="'ssxm'" input-align="right" name="ssxm" :required="isRequired('ssxm')"
                   :value="formData.ssxm" :rules="getRules('ssxm')" label="所属项目" placeholder="请选择项目">
          <template #input>
            <view-item @click.native="isShowPopup(ssxm,'ssxm')" :value="formData.ssxm" placeholder="请选择项目"/>
            <van-popup v-model="ssxm.show" position="bottom">
              <van-nav-bar title="选择项目" left-text="取消" right-text="确定" @click-left="ssxm.show = false"
                           @click-right="popupSubmitSsxm('ssxm',{label:'projectName',value:'projectId'})"/>
              <van-row type="flex" align="center" class="p-r-20">
                <van-col :span="18">
                  <van-search v-model="ssxm.filterText" @input="pickerSearch($event,ssxm,'projectName')" clearable
                              shape="round"/>
                </van-col>
                <van-col :span="6">
                  <van-button :loading="btnLoading" @click="selectMyProjectList('',true)" loading-text="加载中..."
                              type="primary" native-type="button" size="small">更多项目...
                  </van-button>
                </van-col>
              </van-row>
              <van-picker :duration="0" ref="ssxm" value-key="projectName" :columns="ssxm.filteredData"
                          @cancel="ssxm.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'bz'" v-model="formData.bz" :readonly="isDisabled('bz')" :required="isRequired('bz')"
                   name="bz" :rules="getRules('bz')" type="textarea" maxlength="200" rows="3" autosize label="备注"
                   show-word-limit placeholder="请输入备注" input-align="right"/>
        <van-field v-f-show="'fj'" class="fileValueBox" :value.prop="formData.fj" input-align="right" name="fj" :required="isRequired('fj')"
                   :rules="getRules('fj')" label="附件" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('fj')" :files="formData.fj" @success="uploadSuccess"
                         module-type="flow" @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','fj')"></uploadFiles>
          </template>
        </van-field>
      </van-cell-group>
    </van-form>

    <div class="font-32 font-weight-500 cor-00 m-t-26">流程</div>
    <!--      这个是不带选人的流程图    -->
    <flowTrace v-if="!$route.query.reSend && (processInstanceId || $route.query.processInstanceId)" class="m-t-20"
               :flowTraceList="flowTrace" :processInfo="processData"></flowTrace>
    <!--      这个是带选人的流程图    -->
    <approver v-else class="m-t-20" ref="approver" @addUser="addUser" :processData="processData" :formData="formData"
              :formItemMap="formItemMap"/>
    <bottom-bar @submit="submit" @mention="mention"></bottom-bar>
    <van-popup position="bottom" v-model="approver.show">
      <van-nav-bar title="选择办理人" left-text="取消" right-text="确定" @click-left="approver.show = false"
                   @click-right="approverPopupSubmit"/>
      <van-search v-model="approver.filterText" @input="treeSearch($event, $refs.approverTree)" clearable
                  shape="round"/>
      <div style="overflow-y: auto" class="h-vh-50">
        <div class="p-10">
          <el-tree ref="approverTree" @check-change="approverCheckChange($event, $refs.approverTree)" node-key="uuid"
                   check-strictly :data="approver.data" :filter-node-method="filterNode" check-on-click-node
                   show-checkbox/>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {getDeptUserTreeAll, selectMyProjectList} from '@/api/user.js'
import {getFormDataByInstanceId} from "@/api/flow";
import {getDictDataByType} from '@/api/dict'
import cache from "@/plugins/cache";
import mixin from '@/mixin/flow'
import moment from "moment";
import uploadFiles from "@/components/uploadFiles/index.vue";
import fileMixins from "@/components/uploadFiles/fileMixins";
import bottomBar from '@/components/flow/bottom-bar.vue'
import flowTrace from '@/components/flow/flowTrace.vue'
import approver from "@/components/flow/approver.vue";

export default {
  components: {approver, flowTrace, bottomBar, uploadFiles},
  mixins: [mixin,fileMixins],
  data() {
    return {
      minDate: new Date(2024, 0, 1),
      moment,
      btnLoading: false,
      formData: {
        flowNo: '',
        sqr: "关瀚涛",
        ssbm: "",
        yyrq: "",
        yywjzl: "",
        wjfs: "",
        yywjmc: "",
        syhgsz: "",
        yzlx: "",
        ffwjyz: "",
        ghrq:"",
        ssxm: "",
        bz: "",
        fj: [],
      },
      // 用印日期
      yyrq: {
        show: false,
      },
       // 用印日期
      ghrq: {
        show: false,
      },
      rules: {},
      // 所属项目
      ssxm: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      // 选人树
      approver: {
        data: [],
        filterText: '',
        show: false
      },
      // 部门用户树
      deptUserTreeAll: {
        data: [],
        filterText: '',
        show: false
      },
      yywjzl: {
        data: [],
        filteredData: [],
        show: false
      },
      syhgsz: {
        data: [],
        filteredData: [],
        show: false
      },
      yzlx: {
        data: [],
        filteredData: [],
        show: false
      },
      ffwjyz: {
        data: ['否', '是'],
        filteredData: ['否', '是'],
        show: false
      },
      formItemMap: null, // 表单字段的Map
      ffwjyzBool:false
    }
  },

  created() {
    const {templateId, groupId, reSend} = this.$route.query
    this.SET_TEMPLATE_ID(templateId)
    this.SET_GROUP_ID(groupId)
    this.init()
    if (reSend && this.$route.query.processInstanceId) { // 重新发起时
      this.$loading.show()
      this.getFormInfo({templateId: this.templateId}).then(res => {
        this.formItemMap = new Map(res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
        // 从后台去流程表单数据 只取fomData
        getFormDataByInstanceId(this.$route.query.processInstanceId).then(form => {
          // 合并
          Object.assign(this.formData, res.data.processTemplates.expressVals, form.data)
          this.$loading.hide()
        })
      })
      // / 新增时 初始化的时候预定人是当前登录用户
      const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
      this.selectMyProjectList(currentUserInfo)
    } else if (this.$route.query.processInstanceId && !this.$route.query.reSend) { // 外部跳转时
      this.SET_PROCESS_INSTANCE_ID(this.$route.query.processInstanceId)
      if (this.$route.query.taskId) {
        this.SET_TASK_ID(this.$route.query.taskId)
      }
      this.$loading.show()
      this.getProcessInfo({
        processInstanceId: this.$route.query.processInstanceId,
        taskId: this.$route.query.taskId
      }).then(res => {
        Object.assign(this.formData, res.data.formData)
        this.$loading.hide()
      })
    } else { // 新增时
      // 新增时调用
      this.getFormInfo({templateId: this.templateId, groupId: this.groupId}).then(res => {
        this.formItemMap = new Map(res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
        Object.assign(this.formData, res.data.processTemplates.expressVals)
      })
      // 新增时 初始化的时候预定人是当前登录用户
      const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
      // this.formData.ssbm = currentUserInfo.dept.deptName
      this.selectMyProjectList(currentUserInfo)
    }
  },
  methods: {
    popupSubmitFfwjyz(val){
      console.log(val)
      const item =this.$refs[val].getValues()[0]
      console.log(item)
      this.ffwjyzBool = item == '是' ? true : false;
      this.$set(this[val], 'show', false)
      this.formData[val]=item
      this.$set(this.formData, val, item)
    },
    // 进页面就调用
    init() {
      // 获取部门用户树
      this.getDeptUserTreeAll()
      // 用印文件类型
      getDictDataByType('seal_file_type').then(res => {
        const data = res.data.map(item => {
          return item.dictLabel
        })
        this.yywjzl.data = data
        this.yywjzl.filteredData = data
      })
      // 子公司列表
      getDictDataByType('subsidiary_seal_list').then(res => {
        const data = res.data.map(item => {
          return item.dictLabel
        })
        this.syhgsz.data = data
        this.syhgsz.filteredData = data
      })
      // 印章类型
      getDictDataByType('seal_type').then(res => {
        const data = res.data.map(item => {
          return item.dictLabel
        })
        this.yzlx.data = data
        this.yzlx.filteredData = data
      })
    },
    uploadSuccess(fileList) { // 每次都会filelist全部丢出来
      this.formData.fj = fileList
    },
    handleClick(item) {
      if (this.formData.yzlx) {
        this.formData.yzlx = this.formData.yzlx + "," + item
      } else {
        this.formData.yzlx = item
      }
    },
    yyrqConfirm(date) {
      this.formData.yyrq = moment(date).format('YYYY-MM-DD')
      this.yyrq.show = false
    },
    //归还日期
    ghrqConfirm(date) {
      this.formData.ghrq = moment(date).format('YYYY-MM-DD')
      this.ghrq.show = false
    },
    // 人员、部门树
    getDeptUserTreeAll() {
      const _this = this
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', data)
          this.$set(this.approver, 'data', data)
        })
      })
    },
    // 获取人员所属项目列表
    selectMyProjectList(user, more) {
      this.btnLoading = true
      return new Promise(resolve => {
        selectMyProjectList({projectMember: user.id || user.userId, more}).then(res => {
          this.btnLoading = false

          this.ssxm.data = res.rows
          this.ssxm.filteredData = res.rows
          resolve(res.rows)
        })
      })
    },
  }
}
</script>
